import { createFileRoute } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { Footer } from "@/components/Footer/Footer";
import { FlightSearchForm } from "@/features/flights/components/FlightSearchForm/FlightSearchForm";
import { useFlightSearchForm } from "@/features/flights/hooks/flightSearch/useFlightSearchForm";
import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";
import { SearchCategorySwitcher } from "@/features/search/components/SearchCategorySwitcher";

export const Route = createFileRoute("/_authenticated/flights/search")({
  component: RouteComponent,
});

function RouteComponent() {
  const intl = useIntl();

  const navigate = Route.useNavigate();

  const { handleSubmit: handleFlightSearchFormSubmit } = useFlightSearchForm();

  const handleFlightSearchSubmit = (values: FlightSearchFormValues) => {
    handleFlightSearchFormSubmit(values);
    navigate({ to: "/flights/departure/list" });
  };

  return (
    <main className="main">
      <div className="w-full space-y-3 p-main">
        <SearchCategorySwitcher current="flights" />

        <div className="rounded-4xl bg-surface-base-light p-4 shadow-md">
          <FlightSearchForm
            submitButtonContent={intl.formatMessage({
              id: "flights.search.searchFlight",
              defaultMessage: "Search flight",
            })}
            onSubmit={handleFlightSearchSubmit}
            analyticsSource="main"
          />
        </div>
      </div>

      <Footer />
    </main>
  );
}
